export const educationData = [
    {
        id: 1,
        institution: 'TU Graz (Software Engineering and Management)',
        course: 'Bachelor Degree',
        startYear: '2020',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Katolicki skolski centar Sv. Pavao, Zenica',
        course: 'Gymnasium',
        startYear: '2014',
        endYear: '2018'
    },
    {
        id: 3,
        institution: 'Katolicki skolski centar Sv. Pavao, Zenica',
        course: 'Primary School',
        startYear: '2005',
        endYear: '2014'
    },
]